var applyFilters = function applyFilters(filters, options, searchText) {
  var filterGroup = filters.map(function () {
    return [];
  });
  options.forEach(function (option) {
    // check each filter for a match
    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      var isValid = filter(searchText, option);
      // Matches this filter.
      // Add to to result group and break loop
      if (isValid) {
        filterGroup[i].push(option);
        break;
      }
    }
  });

  // Join filter groups
  var filterResults = filterGroup.reduce(function (all, group) {
    all.push.apply(all, group);
    return all;
  }, []);
  return filterResults;
};

// this prevents duplicate values from being added
var checkCurrentValuesForCustomValue = function checkCurrentValuesForCustomValue(searchText, availableOptions) {
  var containsMatchingValue = false;
  availableOptions.map(function (option) {
    if (option.label.toUpperCase() === searchText.toUpperCase()) {
      containsMatchingValue = true;
    }
  });
  return containsMatchingValue;
};
function createCustomValueOption(searchText, availableOptions) {
  // check to see if option value is already in the options list
  var doesOptionExist = checkCurrentValuesForCustomValue(searchText, availableOptions);
  if (!doesOptionExist) {
    // return it in option format
    return {
      id: '@@' + searchText + '@@',
      isNew: true,
      label: searchText,
      value: searchText
    };
  }
  return false;
}

// only utilized if grouped is true
function groupOptionsList(visibleOptions, allowCustomInputValue, searchText, availableOptions) {
  // set vars
  var groupedOptions = [];
  var ungroupedOptions = [];
  var finalGroups = [];
  // group all options
  visibleOptions.map(function (option) {
    if (option.group && !groupedOptions[option.group]) {
      groupedOptions[option.group] = [];
      groupedOptions[option.group].push(option);
    } else if (option.group && groupedOptions[option.group]) {
      groupedOptions[option.group].push(option);
    } else {
      ungroupedOptions.push(option);
    }
  });
  // massage data for use in the component
  for (var group in groupedOptions) {
    finalGroups.push({
      name: group,
      values: groupedOptions[group]
    });
  }
  // alphabetize by group
  finalGroups = finalGroups.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });

  // check if we should include custom input values and put it at the bottom of the list
  if (allowCustomInputValue && searchText && createCustomValueOption(searchText, availableOptions)) {
    ungroupedOptions.push(createCustomValueOption(searchText, availableOptions));
  }

  // add ungrouped options to the top of the list if there are ungrouped options
  if (ungroupedOptions.length > 0) {
    finalGroups.unshift({
      name: 'Ungrouped',
      values: ungroupedOptions
    });
  }
  return finalGroups;
}
function createVisibleOptionsList(optionFilter, type) {
  var filters = Array.isArray(optionFilter) ? optionFilter : [optionFilter];
  return function (searchText, availableOptions, allowCustomInputValue, customOptions, allowSelectAll, multiselect) {
    var filterArray = filters;
    var noSearchText = searchText === null || searchText === undefined || !searchText.length;

    // if there's no search text, don't filter, just return options
    if (noSearchText) {
      filterArray = [function () {
        return true;
      }];
    }

    // get the currently visible options
    var allVisibleOptions = availableOptions.concat(customOptions);
    var visibleOptions = applyFilters(filterArray, allVisibleOptions, searchText);
    if ((customOptions === null || customOptions === void 0 ? void 0 : customOptions.length) > 0) {
      availableOptions = customOptions.concat(visibleOptions);
    }

    // if custom input options are allowed, and there is search text entered
    if (allowCustomInputValue && !noSearchText && type !== 'grouped' && createCustomValueOption(searchText, availableOptions)) {
      // and add it to the bottom of the visible options array
      visibleOptions.push(createCustomValueOption(searchText, availableOptions));
    }

    // if this is a grouped options list, group and add custom values in a special function
    if (type === 'grouped') {
      visibleOptions = groupOptionsList(visibleOptions, allowCustomInputValue, searchText, availableOptions);
    }
    if (allowSelectAll && multiselect) {
      if (type === 'grouped') {
        var temp = {
          name: 'Ungrouped',
          values: [{
            id: 'selectAll',
            label: 'Select All',
            value: 'Select All'
          }]
        };
        visibleOptions.unshift(temp);
      } else {
        visibleOptions.unshift({
          id: 'selectAll',
          label: 'Select All',
          value: 'Select All'
        });
      }
    }
    // return the visible options, with the custom input value if applicable
    return visibleOptions;
  };
}

export { createCustomValueOption, createVisibleOptionsList as default, groupOptionsList };
